var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEyeClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.304 7.304C7.0682 7.52372 6.87908 7.78868 6.7479 8.08308C6.61673 8.37748 6.54619 8.69528 6.54051 9.01753C6.53482 9.33978 6.5941 9.65987 6.71481 9.95871C6.83551 10.2576 7.01518 10.529 7.24308 10.7569C7.47098 10.9848 7.74245 11.1645 8.04129 11.2852C8.34013 11.4059 8.66022 11.4652 8.98247 11.4595C9.30472 11.4538 9.62252 11.3833 9.91692 11.2521C10.2113 11.1209 10.4763 10.9318 10.696 10.696M7.984 3.464C8.32105 3.42201 8.66035 3.40063 9 3.4C14.6 3.4 17 9 17 9C16.6423 9.7657 16.1938 10.4855 15.664 11.144M4.688 4.688C3.097 5.7717 1.8239 7.26021 1 9C1 9 3.4 14.6 9 14.6C10.5327 14.6041 12.0326 14.1561 13.312 13.312M1 1L17 17",
    stroke: "#BEBEBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeClose);
export default __webpack_public_path__ + "static/media/password-eye-close.78b8403f9accd4fad837e6ecf8684865.svg";
export { ForwardRef as ReactComponent };